module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('apartment-bulk-add-blank-form', {
    attrs: {
      "submit-label": "Массово добавить квартиры",
      "apartment": _vm.apartment,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processApartmentForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507dffe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/apartment/ApartmentBulkAddForm.vue
// module id = 643
// module chunks = 0